export type StatusTone = 'success' | 'warning' | 'destructive' | 'black' | 'neutral';

const TONES: Record<string, StatusTone> = {
  valid: 'success',
  active: 'success',
  scheduled: 'success',
  trialing: 'success',
  paid: 'success',
  succeeded: 'success',
  enabled: 'success',
  recovered: 'success',
  on_sale: 'success',
  complimentary: 'success',
  partially_paid: 'warning',
  unpaid: 'warning',
  past_due: 'warning',
  canceled: 'destructive',
  failed: 'destructive',
  incomplete_expired: 'destructive',
  sold_out: 'black',
};

/** The color family a record's status badge takes, the same in the dashboard and the portal. */
export function statusTone(status: string | null | undefined): StatusTone {
  return TONES[status ?? ''] ?? 'neutral';
}
